import React from "react";
import { XCircle } from "lucide-react";

// Navbar6.js
// Basic navbar for the "ReviseView" page.
// Left side shows "{pageTitle} (revising)" in bold.
// Right side has a close button that triggers onClose.

const Navbar6 = ({ pageTitle, onClose }) => {
  return (
    <nav className="flex items-center justify-between p-6 border-b bg-white">
      <div className="text-xl font-bold text-black">{pageTitle} (revising)</div>
      <div>
        <button
          onClick={onClose}
          className="text-gray-600 hover:text-black transition-colors duration-200"
          title="Close"
        >
          <XCircle size={24} />
        </button>
      </div>
    </nav>
  );
};

export default Navbar6;
